import { z } from "zod";
import { Timestamp } from "../common/time.js";
import { defineRoute } from "../http/route.js";
/** Most delays a report carries: a sample of a minute's deliveries (card 163). */
export const REPORT_DELAYS_MAX = 50;
const count = z.number().int().nonnegative().max(100_000);
/**
 * What a desktop saw of live delivery over about a minute (ADR 0029, section 12; card 163): counts and times only,
 * never a message's text or anyone's id. The delays are measured against each entry's `sentAt` by the desktop's own
 * clock, which the server corrects with the report's own `sentAt`.
 */
export const DeliveryReport = z
    .object({
    sentAt: Timestamp.describe("When the desktop sent the report, by its own clock"),
    deliveries: count.describe("Entries that arrived on the live connection"),
    delaysMs: z
        .array(z.number().int().min(-3_600_000).max(3_600_000))
        .max(REPORT_DELAYS_MAX)
        .describe("A sample of those entries' delays, from their `sentAt` to their arrival, by the desktop's clock"),
    gaps: count.describe("Entries that came ahead of the next number, so that the gap was fetched"),
    failedRecoveries: count.describe("Reconnects after which Centrifugo could not recover what was missed"),
    failedSyncs: count.describe("Syncs that failed, to be tried again"),
})
    .meta({ id: "DeliveryReport" });
export const reportDelivery = defineRoute({
    surface: "tenant",
    auth: "user",
    permission: "conversation:create",
    id: "messaging.reports.create",
    method: "POST",
    path: "/v1/messaging/reports",
    marks: ["tenant"],
    summary: "A desktop's report of live delivery over the last minute, for the platform's metrics: counts and delays only, never a message's text or anyone's id",
    prd: ["IM-1"],
    request: { body: DeliveryReport },
    responses: { 204: { description: "Taken" } },
    errors: ["AUTH_REQUIRED", "TENANT_REQUIRED", "PERMISSION_DENIED", "VALIDATION_FAILED"],
});
export const reportRoutes = [reportDelivery];
//# sourceMappingURL=report.routes.js.map